class Favourites extends CollectionPanel {

	constructor(title: string) {
		super(title)

		this.isCollectionView = false;

		this.view();
		this.setUpEvents();
		this.getData();
	}

}